import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FaunaSpecies } from '../../apiService/ObservationApiService';

interface SpeciesGroupState {
  data: FaunaSpecies[];
  lastUpdated: number | null;
}

const initialState: SpeciesGroupState = {
  data: [],
  lastUpdated: null,
};

const speciesGroupSlice = createSlice({
  name: 'speciesGroup',
  initialState,
  reducers: {
    setSpeciesGroup(state, action: PayloadAction<FaunaSpecies[]>) {
      state.data = action.payload;
      state.lastUpdated = Date.now();
    },
    clearSpeciesGroup(state) {
      state.data = [];
      state.lastUpdated = null;
    },
  },
});

export const { setSpeciesGroup, clearSpeciesGroup } = speciesGroupSlice.actions;
export default speciesGroupSlice.reducer;
